
require('./bootstrap')
require('./lib/polyfill/node-list-foreach')
require('./lib/polyfill/parent-node-prepend')
require('./lib/polyfill/reflect')
// require('./lib/polyfill/object-assign')

window.swal = require('sweetalert')




// WEBPACK FOOTER //
// ./resources/assets/js/app.js